import React from 'react'
import AccessCodesList from '../components/access-codes/access-codes-list'
import { CalloutBox, DivContentBox, DivTitleBox } from '../components/common/styled'

const AccessCodes = () => (
  <div className='ibox float-e-margins animated fadeIn section-shadow'>
    <DivTitleBox className='ibox-title'>
      <div className='row'>
        <div className='col-xs-12 col-sm-12'>
          {' '}
          <h2>Access Codes</h2>
        </div>
      </div>
    </DivTitleBox>
    <DivContentBox className='ibox-content animated fadeIn'>
      <CalloutBox>
        <p>Below are the Access Codes associated to your account.</p>
        <p>Access codes guide the user through our KYC flow and are single use</p>
        <p>
          You may not generate access codes from this page. Contact to your account representative if you need more
          codes
        </p>
        <p>
          <b>NOTE:</b> it is very important that you do association of the user at YOUR side. Do not send these out
          unless your data administrator has confirmed that there is no association to this user previously and that
          they will track future associations. We do not track when you send out link. Only after a user completes KYC
          under that code.
        </p>
        <p>You may filter by the following criteria</p>
        <p>
          <b>- Code:</b> the access code itself. Lower case
        </p>
        <p>
          <b>- Is active:</b> if a code is not active then it has been allocated to an identity / transaction and cannot
          be reused
        </p>
        <p>
          <b>- Has A parent:</b> If a code has a parent then it is part of a restart scenario and should NOT be
          allocated to a user
        </p>
      </CalloutBox>

      <AccessCodesList />
    </DivContentBox>
  </div>
)

export default AccessCodes
